import { connect } from 'react-redux';

import SectionForm from '../components/SectionForm';
import { createLine } from '../actions/line';
import { createSection, addLineToSection, updateSection, deleteSection } from '../actions/sections';
import { addSectionToStructure, removeSectionFromStructure } from '../actions/structure';

function parseMatch(state, match = { params: {} }) {
  // const { id = undefined, sectionIndex = undefined, lineIndex = undefined } = match.params;

  const params = {
    id: parseInt(match.params.id, 10) || undefined,
    sectionIndex: parseInt(match.params.sectionIndex, 10),
  };

  const section =
    state.song.sections.byId[
      params.id ||
        (params.sectionIndex >= 0 ? state.song.structure[params.sectionIndex] : undefined)
    ];

  return { ...params, section };
}

// function getSection(state, ownProps) {
//   const id = idFromRoute(ownProps);
//   return ownProps.section || (id ? state.song.sections.byId[id] : undefined);
// }

const mapStateToProps = (state, ownProps) => {
  if (ownProps.section) {
    return {
      ...ownProps,
      obj: ownProps.section,
    };
  } else if (ownProps.match) {
    const m = parseMatch(state, ownProps.match);
    return {
      ...ownProps,
      ...m,
      obj: m.section,
    };
  }
  return ownProps;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDelete: (ev, id) => {
    ev.preventDefault();
    ownProps.history.push('/');
    dispatch(deleteSection(id));
  },
  onRemove: (ev, index) => {
    ownProps.history.push('/');
    dispatch(removeSectionFromStructure(index));
  },
  onChange: (obj) => {
    dispatch(updateSection(obj));
  },
  onCreate: (obj) => {
    const section = dispatch(createSection({ type: obj.type || '', label: obj.label || '' }));

    const lyricLines = obj.lyrics
      .split('\n')
      .map(ln => ln.trim())
      .filter(ln => ln);

    const lines = lyricLines.map(ln => dispatch(createLine({ text: ln })));

    lines.map(line => dispatch(addLineToSection(section.obj.id, line.obj.id)));

    if (obj.addToSong || true) {
      dispatch(addSectionToStructure(section.obj.id));
    }
    ownProps.history.push('/');
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SectionForm);



// WEBPACK FOOTER //
// ./src/containers/SectionFormContainer.js